module.exports = __webpack_public_path__ + "media/images/sarapoint/t3-312074f752ac4f6d54e6837f050bdc94.png";